import { EnumDictionary } from '../interfaces/enumDictionary';

// eslint-disable-next-line import/export, no-shadow, no-unused-vars
enum BanksServices {
    // eslint-disable-next-line no-unused-vars
    Prepay = 'prepay'
}

const BanksList: EnumDictionary<BanksServices, string> = {
  [BanksServices.Prepay]: 'Recarga Pré-pago'
};

// eslint-disable-next-line import/export
export { BanksServices, BanksList };
